import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import styles from './back-button.module.scss';

const BackButton = ({
  name,
  onClick,
  customClassName,
}: {
  name?: string;
  onClick?: () => void;
  customClassName?: string;
}) => {
  const { t: tA11y } = useTranslation('a11y');

  return (
    <div className={clsx(styles.button, customClassName)}>
      <button
        onClick={onClick}
        className={styles.button__btn}
      >
        <svg
          fill="none"
          viewBox="0 0 9 16"
          className={styles.button__icon}
          aria-label={tA11y('A11Y.ICON.BACK')}
        >
          <path
            d="M8.125 1.12616L1.25 8.00116L8.125 14.8762"
            stroke="#1A1A1A"
          />
        </svg>

        {name}
      </button>
    </div>
  );
};

export default BackButton;
